import React from 'react';
import styled from 'styled-components';

const Tooltip = ({
  className, position = 'top', children, show = false,
}) => (
  <div
    className={`${className} tooltip bs-tooltip-${position} fade ${show && 'show'}`}
    role="tooltip"
  >
    <div className="arrow" />
    <div className="tooltip-inner">{children}</div>
  </div>
);

export default styled(Tooltip)``;
